/* eslint-disable react/jsx-wrap-multilines */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';

import WarningIcon from '@mui/icons-material/Warning';

import Skeleton from '@mui/material/Skeleton';

import { CourseStatus } from '@ts-core/utils/Constants';
import ConfirmButton from '@ts-core/components/ConfirmButton';

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.secondary.contrastText,
    fontWeight: 500,
  },
  button: {
    color: theme.palette.secondary.contrastText,
    ...theme.typography.subtitle1,
    fontWeight: 500,
    marginLeft: theme.spacing(0.5),
    textDecoration: 'underline',
  },
}));

const PeriodStatus = (props) => {
  const { course, loading, onToggleCourseStatus } = props;
  const classes = useStyles();

  const isPeriodOpen = course.periodStatus === CourseStatus.Active;

  const handleToggleCourseStatus = useCallback(() => {
    onToggleCourseStatus(course);
  }, [onToggleCourseStatus, course]);

  const alertMessage = useMemo(() => {
    if (!isPeriodOpen) {
      return undefined;
    }
    return (
      <>
        Se borraran todos los alumnos del curso, así como también las entregas y todos los datos estadísticos del período.
        <br />
        <Box component="span" color="error.main" fontWeight={700} display="flex" alignItems="flex-end">
          <WarningIcon sx={{ mr: 1, mt: 1 }} />
          Esta acción no se puede deshacer.
        </Box>
      </>
    );
  }, [isPeriodOpen]);

  return (
    <Box display="flex" mt={2}>
      {loading ? (
        <Skeleton width={180} />
      ) : (
        <>
          <Typography variant="subtitle1" className={classes.text}>
            <FormattedMessage id={isPeriodOpen ? 'course.periodInfo.open' : 'course.periodInfo.closed'} />
            {' -'}
          </Typography>
          <ConfirmButton
            onConfirm={handleToggleCourseStatus}
            alertTitle={<FormattedMessage id={isPeriodOpen ? 'dialog.confirmClosePeriod' : 'dialog.confirmOpenPeriod'} />}
            alertMessage={alertMessage}
            renderButton={({ onClick }) => (
              <ButtonBase onClick={onClick} className={classes.button}>
                <FormattedMessage id={isPeriodOpen ? 'course.periodAction.close' : 'course.periodAction.open'} />
              </ButtonBase>
            )}
          />
        </>
      )}
    </Box>
  );
};

PeriodStatus.propTypes = {
  course: PropTypes.object,
  loading: PropTypes.bool,

  onToggleCourseStatus: PropTypes.func.isRequired,
};

PeriodStatus.defaultProps = {
  course: {},
  loading: false,
};

export default PeriodStatus;
